import { create } from "zustand";

interface LiveshowsState {
  hasActiveLiveshow?: boolean;
  setHasActiveLiveshow: (hasActiveLiveshow: boolean) => void;
}

export const useLiveshowsStore = create<LiveshowsState>((set) => ({
  hasActiveLiveshow: undefined,
  setHasActiveLiveshow: (hasActiveLiveshow) => set({ hasActiveLiveshow }),
}));

interface LiveshowModalState {
  showLiveshowModal: boolean;
  shouldAutoplay: boolean;
  setShowLiveshowModal: (show: boolean) => void;
  setShouldAutoplay: (shouldAutoplay: boolean) => void;
}

export const useLiveshowModalStore = create<LiveshowModalState>((set) => ({
  showLiveshowModal: false,
  shouldAutoplay: false,
  setShowLiveshowModal: (showLiveshowModal) => set({ showLiveshowModal }),
  setShouldAutoplay: (shouldAutoplay) => set({ shouldAutoplay }),
}));
